/** Fixed UDO templates owned by the Assets capability. */
export enum AssetsWorkspaceCapabilityUdoTemplateKey {
    asset = "23edc72f-79b1-44d7-bb46-16b22c470052",
}
